module.exports = __webpack_public_path__ + "static/media/Item_Weapon_Mk12_C.22c191ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Main/Item_Weapon_Mk12_C.png
// module id = 232
// module chunks = 0